import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import ApiService from '../../data/services/ApiService'
import { handleExchangeSuccess } from '../../helpers/authExchangeHelper'

const Exchange = (props) => {
    const dispatch = useDispatch()
    const history  = useHistory()
    const [error, setError] = useState(null)

    useEffect(() => {
        const params = new URLSearchParams(props.location.search)
        const token  = params.get('token')

        if (!token) {
            history.replace('/login')
            return
        }

        ApiService.exchangeToken(token)
            .then(response => {
                handleExchangeSuccess(response.data, dispatch, history)
            })
            .catch(err => {
                const msg =
                    err.response?.data?.message ||
                    'El enlace de acceso expiró o ya fue utilizado. Por favor inicia sesión.'
                setError(msg)
            })
    }, []) // eslint-disable-line

    if (error) {
        return (
            <div style={{
                display:        'flex',
                flexDirection:  'column',
                alignItems:     'center',
                justifyContent: 'center',
                minHeight:      '100vh',
                padding:        '24px',
                textAlign:      'center'
            }}>
                <p style={{ color: '#B52C21', fontSize: 16, marginBottom: 16 }}>
                    {error}
                </p>
                <a href="/login" style={{ color: '#556ee6', fontSize: 14 }}>
                    Iniciar sesión
                </a>
            </div>
        )
    }

    return (
        <div style={{
            display:        'flex',
            flexDirection:  'column',
            alignItems:     'center',
            justifyContent: 'center',
            minHeight:      '100vh'
        }}>
            <p style={{ color: '#74788d', fontSize: 15 }}>Iniciando sesión...</p>
        </div>
    )
}

export default Exchange
